// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AIModerationAssistSetting-module__icon-wrapper--ulEmE{display:flex;align-items:center}.AIModerationAssistSetting-module__info-icon--NPmph{height:16px;width:16px}.AIModerationAssistSetting-module__info-icon--NPmph rect{fill:#000}.AIModerationAssistSetting-module__tooltip--ANOlG{max-width:330px}.AIModerationAssistSetting-module__disabled--n7SmF{opacity:.5}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon-wrapper": `AIModerationAssistSetting-module__icon-wrapper--ulEmE`,
	"iconWrapper": `AIModerationAssistSetting-module__icon-wrapper--ulEmE`,
	"info-icon": `AIModerationAssistSetting-module__info-icon--NPmph`,
	"infoIcon": `AIModerationAssistSetting-module__info-icon--NPmph`,
	"tooltip": `AIModerationAssistSetting-module__tooltip--ANOlG`,
	"disabled": `AIModerationAssistSetting-module__disabled--n7SmF`
};
export default ___CSS_LOADER_EXPORT___;
